const locale = {
  placeholder: 'Roghnaigh am',
};

export default locale;
